export function Logo({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="relative h-7 w-7">
        <svg viewBox="0 0 32 32" className="h-full w-full">
          <defs>
            <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="oklch(0.85 0.18 195)" />
              <stop offset="1" stopColor="oklch(0.55 0.20 240)" />
            </linearGradient>
          </defs>
          <path d="M16 2 L29 9 V23 L16 30 L3 23 V9 Z" fill="none" stroke="url(#lg)" strokeWidth="1.5" />
          <circle cx="16" cy="16" r="3" fill="url(#lg)" />
          <circle cx="16" cy="16" r="6" fill="none" stroke="url(#lg)" strokeWidth="0.8" opacity="0.6" />
          <circle cx="16" cy="16" r="9" fill="none" stroke="url(#lg)" strokeWidth="0.5" opacity="0.3" />
        </svg>
      </div>
      <div className="leading-none">
        <div className="font-display text-[15px] font-semibold tracking-tight">CARIO<span className="text-cyan"> INTEL</span></div>
        <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-muted-foreground mt-0.5">OSINT // CLASSIFIED</div>
      </div>
    </div>
  );
}
